const validReferrer = (referrer: string) => {
    switch(referrer){
        case 'tso':
        case 'tsocheckout':
        case 'tsoprntquote':
        case 'tcs':
        case 'beta':
        case 'myschl':
        case 'corphome':
        case 'bw':
        case 'tcb':
        case 'sso':
        case 'ssocheckout':
        case 'ssocoreg':
        case 'ssocosignin':
        case 'pcs':
        case 'ofesso':
        case 'cptk':
        case 'vms':
        case 'ewallet':
        case 'classmags':
        case 'lah':
        case 'clubs':
        case 'sdm':
        case 'rif':
        case 'cos':
        case 'face':
        case 'lp':
        case 'nys':
        case 'usor':
        case 'ror':
        case 'cmplus':
        case 'pportal':
        case 'bfaem':
        case 'os':
        case 'edu':
        case 'storyvoice':
        case 'sdc':
        case 'literacy':
        case 'mbss':
            return true;
        default:
            return false;
    }
}

export default validReferrer;